import {IFields} from './applicationFeature';


export class ParentUser {
  fields: IFields[];
  constructor() {
    this.fields = [];
    this.fields = [ { label: 'Όνομα', field: 'firstName', type: 'text', value: '', searchType: '' },
      { label: 'Επώνυμο', field: 'lastName', type: 'text', value: '', searchType: '' },
      { label: 'Email', field: 'email', type: 'text', value: '', searchType: '' },
      { label: 'Τηλέφωνο', field: 'telephone', type: 'text', value: '', searchType: '' },
     ];
  }

  getSearchFields() {
    return this.fields;
  }
}
